module.exports = __webpack_public_path__ + "img/icon-total-area.74d8044a.svg";